import axios from "../../../axios/index.js";

export default {
  init() {
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      },
    );
  },
  login(email, pwd, remember) {
    return axios.post("auth/login", {
      email,
      password: pwd,
      remember,
    });
  },
  registerUser(name, email, pwd) {
    return axios.post("auth/signup", {
      name,
      email,
      password: pwd,
    });
  },
  refreshToken() {
    return axios.post("auth/refresh-token", {
      accessToken: localStorage.getItem("accessToKen"),
    });
  },
};
